import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SETTORI = [
  "Industria / Manifatturiero",
  "Hotel / Turismo",
  "Supermercato / GDO",
  "Ristorazione",
  "Ufficio / Terziario",
  "Logistica / Magazzini",
  "Sanità / Cliniche",
  "Agricoltura / Agroalimentare",
  "Fonderia / Metallurgia",
  "Tessile",
  "Altro",
];

export const PROVINCE = [
  "Agrigento","Alessandria","Ancona","Aosta","Arezzo","Ascoli Piceno","Asti","Avellino",
  "Bari","Barletta-Andria-Trani","Belluno","Benevento","Bergamo","Biella","Bologna","Bolzano",
  "Brescia","Brindisi","Cagliari","Caltanissetta","Campobasso","Caserta","Catania","Catanzaro",
  "Chieti","Como","Cosenza","Cremona","Crotone","Cuneo","Enna","Fermo","Ferrara","Firenze",
  "Foggia","Forlì-Cesena","Frosinone","Genova","Gorizia","Grosseto","Imperia","Isernia","La Spezia",
  "L'Aquila","Latina","Lecce","Lecco","Livorno","Lodi","Lucca","Macerata","Mantova","Massa-Carrara",
  "Matera","Messina","Milano","Modena","Monza e Brianza","Napoli","Novara","Nuoro","Oristano","Padova",
  "Palermo","Parma","Pavia","Perugia","Pesaro e Urbino","Pescara","Piacenza","Pisa","Pistoia","Pordenone",
  "Potenza","Prato","Ragusa","Ravenna","Reggio Calabria","Reggio Emilia","Rieti","Rimini","Roma","Rovigo",
  "Salerno","Sassari","Savona","Siena","Siracusa","Sondrio","Sud Sardegna","Taranto","Teramo","Terni","Torino","Trapani",
  "Trento","Treviso","Trieste","Udine","Varese","Venezia","Verbano-Cusio-Ossola","Vercelli","Verona",
  "Vibo Valentia","Vicenza","Viterbo",
];

export const fmtEur = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "€ –";
  return "€ " + Math.round(Number(v)).toLocaleString("it-IT");
};

export const fmtNum = (v, d = 0) => {
  if (v === null || v === undefined || isNaN(v)) return "–";
  return Number(v).toLocaleString("it-IT", { maximumFractionDigits: d });
};

// Download the report PDF as a real file (works inside iframes / avoids popup blockers)
export async function downloadReportPdf(leadId, filename = "audit.pdf") {
  const res = await api.get(`/leads/${leadId}/report/pdf`, {
    responseType: "blob",
    params: { t: Date.now() },
    headers: { "Cache-Control": "no-cache" },
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 2000);
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function createManualLead(fields) {
  const { data } = await api.post(`/admin/leads/manual`, fields);
  return data;
}

export async function getPreventivo(leadId) {
  const { data } = await api.get(`/admin/leads/${leadId}/preventivo`, { params: { t: Date.now() } });
  return data;
}

export async function savePreventivo(leadId, preventivo) {
  const { data } = await api.put(`/admin/leads/${leadId}/preventivo`, { preventivo });
  return data;
}

export async function listPreventivi() {
  const { data } = await api.get(`/admin/preventivi`, { params: { t: Date.now() } });
  return data;
}

export async function regeneratePreventivo(leadId) {
  const { data } = await api.post(`/admin/leads/${leadId}/preventivo/regenerate`);
  return data;
}

export async function restorePreventivo(leadId, idx) {
  const { data } = await api.post(`/admin/leads/${leadId}/preventivo/storico/${idx}/restore`);
  return data;
}

export async function regenerateAllPreventivi() {
  const { data } = await api.post(`/admin/preventivi/regenerate-all`);
  return data;
}

function saveBlob(blobData, filename) {
  const url = window.URL.createObjectURL(new Blob([blobData], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 2000);
}

export async function downloadPreventivoStoricoPdf(leadId, idx, filename = "preventivo_archivio.pdf") {
  const res = await api.get(`/admin/leads/${leadId}/preventivo/storico/${idx}/pdf`, { responseType: "blob", params: { t: Date.now() } });
  saveBlob(res.data, filename);
}

export async function downloadPreventivoPdf(leadId, filename = "preventivo.pdf") {
  const res = await api.get(`/leads/${leadId}/preventivo/pdf`, {
    responseType: "blob",
    params: { t: Date.now() },
    headers: { "Cache-Control": "no-cache" },
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 2000);
}

// Poll lead status until it reaches one of the target statuses (or timeout).
// onPoll(data) viene chiamato ad ogni ciclo con la risposta completa (incl. phase1_progress).
export async function waitForStatus(leadId, targets, { interval = 2500, max = 200, onPoll } = {}) {
  for (let i = 0; i < max; i++) {
    await sleep(interval);
    try {
      const { data } = await api.get(`/leads/${leadId}/status`);
      if (onPoll) onPoll(data);
      if (targets.includes(data.status)) return data.status;
    } catch (e) {
      /* transient network error: keep polling */
    }
  }
  return "timeout";
}
